import React from 'react';
import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { SlidingAnimationPageBase } from '../../../common/components/SlidingAnimationPageBase';

export function HardwareConfiguration() {
  const { t } = useTranslation();

  return (
    <SlidingAnimationPageBase title={t('Set Up Hardware.configure new hardware')} backURL={`../../list?direction=back`}>
      <Box px={3}>
        <Box mb={1}>{t('Set Up Hardware.schneider electric').toUpperCase()}</Box>
      </Box>
    </SlidingAnimationPageBase>
  );
}
